import { j as r } from "../jsx-runtime-ClSzPYp4.js";
import { s as a } from "../index.esm-DOxVcNnO.js";
import { Children as f, cloneElement as d, isValidElement as w } from "react";
import { styled as p, css as m } from "styled-components";
import { space as c, compose as g, position as u, layout as C } from "styled-system";
import P from "../Badge/Badge.mjs";
import h from "../typography/Heading/Heading.mjs";
import x from "../typography/Paragraph/Paragraph.mjs";
const y = /* @__PURE__ */ p.li.withConfig({
  shouldForwardProp: (o) => ![
    "variant"
  ].includes(o)
}).withConfig({
  componentId: "sc-568295a3-0"
})([
  "",
  " ",
  ""
], ({ theme: o, variant: n }) => /* @__PURE__ */ m([
  "",
  " ",
  ""
], o.components.flowPoint.base, n && o.components.flowPoint[n]), c), j = /* @__PURE__ */ p.span.withConfig({
  shouldForwardProp: (o) => a(o)
}).withConfig({
  componentId: "sc-568295a3-1"
})([
  "",
  ""
], ({ theme: o }) => o.components.flowPoint.icon), F = /* @__PURE__ */ p(h).withConfig({
  componentId: "sc-568295a3-2"
})([
  "",
  ""
], ({ theme: o, variant: n }) => /* @__PURE__ */ m([
  "color:",
  ";"
], n && o.componentColors.flow.heading[n])), b = /* @__PURE__ */ p(x).withConfig({
  componentId: "sc-568295a3-3"
})([
  "",
  ""
], ({ theme: o, variant: n }) => /* @__PURE__ */ m([
  "color:",
  ";"
], n && o.componentColors.flow.text[n])), S = ({ children: o, headingLevel: n = "2", Icon: e, index: s, title: t, variant: l = "default", ...i }) => /* @__PURE__ */ r.jsxs(y, {
  variant: l,
  "data-qa-id": `flow-point${s ? `-${s}` : ""}`,
  ...i,
  children: [
    e && /* @__PURE__ */ r.jsx(j, {
      as: e,
      color: null,
      mb: "xs",
      size: [
        35,
        null,
        55
      ]
    }),
    s && !e && /* @__PURE__ */ r.jsx(P, {
      "data-qa-id": `flow-point-badge-${s}`,
      mb: "xs",
      children: s
    }),
    t && /* @__PURE__ */ r.jsx(F, {
      variant: l,
      level: n,
      size: "small",
      children: t
    }),
    o && /* @__PURE__ */ r.jsx(b, {
      variant: l,
      pb: 0,
      textAlign: "center",
      children: o
    })
  ]
}), I = /* @__PURE__ */ p.ol.withConfig({
  shouldForwardProp: (o) => a(o) && ![
    "variant"
  ].includes(o)
}).withConfig({
  componentId: "sc-568295a3-4"
})([
  "",
  ""
], ({ theme: o, variant: n }) => /* @__PURE__ */ m([
  "",
  " ",
  " ",
  ""
], o.components.flow.base, n && o.components.flow[n], g(c, u, C))), B = ({ children: o, headingLevel: n, variant: e = "default", ...s }) => /* @__PURE__ */ r.jsx(I, {
  p: "xs",
  variant: e,
  ...s,
  children: f.map(o, (t, l) => {
    var i;
    return t && /* @__PURE__ */ w(t) && t.type === S ? /* @__PURE__ */ d(t, {
      key: l,
      index: l + 1,
      headingLevel: ((i = t == null ? void 0 : t.props) == null ? void 0 : i.headingLevel) ?? n,
      variant: e
    }) : t;
  })
});
export {
  B as Flow,
  S as FlowPoint,
  I as StyledContainer,
  y as StyledFlowPoint,
  j as StyledIcon
};
